import { AxiosHttp } from "../../http/axios";
import SiteLeadRepository, {
  SiteLeadData,
  SiteLeadsResponse,
} from "../repository/siteLeadRepository";

export default class SiteLeadProvider {
  private static instance: SiteLeadProvider;
  private siteLeadRepository: SiteLeadRepository;

  private constructor() {
    this.siteLeadRepository = SiteLeadRepository.getInstance(
      AxiosHttp.getInstance()
    );
  }

  static getInstance(): SiteLeadProvider {
    if (!SiteLeadProvider.instance) {
      SiteLeadProvider.instance = new SiteLeadProvider();
    }
    return SiteLeadProvider.instance;
  }

  async getSiteLeads(): Promise<SiteLeadsResponse> {
    return await this.siteLeadRepository.getSiteLeads();
  }

  async getSiteLeadById(id: string): Promise<SiteLeadData> {
    return await this.siteLeadRepository.getSiteLeadById(id);
  }

  async createSiteLead(
    siteLead: Omit<SiteLeadData, "id" | "createdAt">
  ): Promise<SiteLeadData> {
    return await this.siteLeadRepository.createSiteLead(siteLead);
  }

  async updateSiteLead(
    id: string,
    siteLead: Partial<SiteLeadData>
  ): Promise<SiteLeadData> {
    return await this.siteLeadRepository.updateSiteLead(id, siteLead);
  }

  async deleteSiteLead(id: string): Promise<void> {
    return await this.siteLeadRepository.deleteSiteLead(id);
  }
}
